'use client';

import { Box, Typography } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType, MonetizableEnum } from '@repo/segment/enums';
import type { FilteredReviewContentSectionOffer } from '@repo/supergraph/review/bankingPage/types';
import { StarRating } from '../../../shared/StarRating';

type ProductTitleRowProps = {
  displayName: string;
  overrideCta?:
    | NonNullable<FilteredReviewContentSectionOffer>['ctaOverride']
    | NonNullable<FilteredReviewContentSectionOffer>['cta'];
  analyticsPayload: {
    index: number;
    institutionId?: string;
    offerId: string;
    productId?: string;
    productType: string;
    monetizable?: MonetizableEnum;
  };
  displayRatingBesideName?: boolean;
  starRating?: number;
  shouldShowReviewLink?: boolean;
  reviewLink?: string;
  shouldShowCta?: boolean;
};

export function TitleRow({
  displayName,
  overrideCta,
  analyticsPayload,
  displayRatingBesideName = false,
  shouldShowReviewLink = false,
  starRating,
  reviewLink,
  shouldShowCta = false,
}: ProductTitleRowProps) {
  return (
    <>
      {shouldShowCta && overrideCta ? (
        <CtaLink
          cta={overrideCta}
          monetizable={analyticsPayload.monetizable ?? MonetizableEnum.no}
          analyticsPayload={analyticsPayload}
          linkType={LinkType.OFFER_NAME}
          sx={{
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 500,
            color: 'black',
          }}
        >
          {displayName}
        </CtaLink>
      ) : (
        <Typography variant="textBold" sx={{ fontSize: '20px', fontWeight: 500, color: 'black' }}>
          {displayName}
        </Typography>
      )}

      {displayRatingBesideName && starRating ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <StarRating
            value={starRating}
            withBackground
            href={shouldShowReviewLink ? reviewLink : undefined}
          />
        </Box>
      ) : null}
    </>
  );
}
